/*
 * 0NYX Lab A — Obsidian Luxe · theme.js
 * Linguagem de movimento: luz que acompanha o olhar. Sem bibliotecas.
 * - Hero: feixe de luz segue o ponteiro (rAF, só com mouse, pausa fora da tela).
 * - Pedestal da "Peça em foco": a luz do palco acompanha o ponteiro.
 * - Submenu: abre ao passar o mouse, fecha com Esc ou clique fora.
 */
(() => {
  'use strict';
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  const still = () => (window.Onyx ? window.Onyx.reduceMotion() : window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function follow(el, target, opts = {}) {
    if (!fine.matches || still()) return;
    let raf = null, tx = opts.x || 62, ty = opts.y || 38, cx = tx, cy = ty, visible = true;
    const step = () => {
      cx += (tx - cx) * 0.08;
      cy += (ty - cy) * 0.08;
      target.style.setProperty(opts.vx || '--mx', cx.toFixed(2) + '%');
      target.style.setProperty(opts.vy || '--my', cy.toFixed(2) + '%');
      raf = visible && (Math.abs(tx - cx) > 0.1 || Math.abs(ty - cy) > 0.1) ? requestAnimationFrame(step) : null;
    };
    el.addEventListener('pointermove', (e) => {
      const r = el.getBoundingClientRect();
      tx = ((e.clientX - r.left) / r.width) * 100;
      ty = ((e.clientY - r.top) / r.height) * (opts.yScale || 100);
      if (!raf && visible) raf = requestAnimationFrame(step);
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => { visible = en.isIntersecting; }).observe(el);
    }
  }

  function init(ctx = document) {
    ctx.querySelectorAll('.a-hero[data-spotlight="true"]').forEach((hero) => follow(hero, hero));
    ctx.querySelectorAll('.a-spot__stage').forEach((stage) => {
      const plate = stage.querySelector('.a-plate');
      if (plate) follow(stage, plate, { vx: '--px', vy: '--py', x: 50, y: 34, yScale: 70 });
    });

    ctx.querySelectorAll('[data-mega]').forEach((d) => {
      const item = d.closest('.a-nav__item');
      if (fine.matches) {
        let t;
        item.addEventListener('pointerenter', () => { clearTimeout(t); d.open = true; });
        item.addEventListener('pointerleave', () => { t = setTimeout(() => (d.open = false), 160); });
      }
    });
  }

  document.addEventListener('click', (e) => {
    document.querySelectorAll('[data-mega][open]').forEach((d) => { if (!d.contains(e.target)) d.open = false; });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-mega][open]').forEach((d) => { d.open = false; d.querySelector('summary').focus(); });
  });

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
